/* JRS - Posiziona il sottomenu desktop esattamente sotto la voce principale (28/10/26) */
(() => {
  if (window.__jrsHeaderDropdown) return;
  window.__jrsHeaderDropdown = true;

  const mq = window.matchMedia('(min-width: 750px)');
  const GUTTER = 16;

  function position(li) {
    if (!mq.matches || li.getAttribute('slot') === 'overflow') return;
    const link = li.querySelector(':scope > .menu-list__link');
    const submenu = li.querySelector(':scope > .menu-list__submenu');
    if (!link || !submenu) return;
    const container = submenu.offsetParent;
    if (!container) return;

    const inner = submenu.querySelector('.menu-list__submenu-inner');
    const padStart = inner ? parseFloat(getComputedStyle(inner).paddingLeft) || 0 : 0;
    const title = link.querySelector('.menu-list__link-title') || link;
    const titleRect = title.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const width = submenu.offsetWidth;
    const viewport = document.documentElement.clientWidth;

    // Allinea il testo del sottomenu al testo della voce, senza uscire dallo schermo
    let left = titleRect.left - padStart;
    left = Math.min(left, viewport - GUTTER - width);
    left = Math.max(left, GUTTER);

    submenu.style.setProperty(
      '--jrs-submenu-left',
      Math.round(left - containerRect.left - container.clientLeft) + 'px'
    );
  }

  function handler(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const li = target.closest('.menu-list__list-item');
    if (li && li.closest('header-menu')) position(li);
  }

  document.addEventListener('pointerover', handler, { passive: true });
  document.addEventListener('focusin', handler);
})();
